import * as React from 'react'
import { ReactElement } from 'react'
import BaseCombobox, { BaseComboboxProps } from './BaseCombobox'
import { DisbursementType } from '../../config/registrationConfig'
import useDisbursementTypes from '../../hooks/useDisbursementTypes'

export type DisbursementTypeComboboxProps = Omit<BaseComboboxProps<DisbursementType>, 'getEntityLabel' | 'getEntityValue' | 'entities'>

export default function DisbursementTypeCombobox(props: DisbursementTypeComboboxProps): ReactElement {
    const { disbursementTypes } = useDisbursementTypes()

    return (
        <BaseCombobox<DisbursementType>
            entities={disbursementTypes}
            alphabetical
            getEntityLabel={vat => vat.name}
            getEntityValue={vat => vat.id}
            placeholderKey={'base.disbursementtypecombobox.placeholder'}
            {...props}
        />
    )
}
